import { Row, Col } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import styles from "../../../constants/styles.json";
import Hold from "../../../assets/images/pause-new.svg";
import Cancel from "../../../assets/images/cancel-new.svg";

const CartSummary = ({
  cart,
  pricePrecision,
  currenciesList,
  themeJSON,
  openDisplayParkedBillModal,
  deleteProductModal,
  verifyStock,
  setCart,
  amount,
}) => {
  return (
    <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
      {/* Left: subtotals */}
      <div
        style={{
          background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
          height: "23.5vh",
          width: "60%",
          marginRight: "1%",
          border: "1px solid #fff",
          borderRadius: "7px",
          padding: "0.5vh",
          fontSize: "1vw",
          position: "relative",
        }}
      >
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Subtotal:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
              {parseFloat(cart.subTotal).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.4vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Discount:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
              {parseFloat(cart.discount ? cart.discount : 0).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Tax:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
              {parseFloat(cart.tax).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        {cart.roundOff !== 0 && cart.roundOff !== undefined && (
          <Row style={{ height: "4.5vh" }}>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "0.8vw",
                fontWeight: "500",
                textAlign: "left",
              }}
            >
              <p style={styles.screenStyles.mainScreen.subTotalText}>Round Off:</p>
            </Col>
            <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              &nbsp;
              <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
                {parseFloat(cart.roundOff).toFixed(pricePrecision)}
              </p>
              <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
            </Col>
          </Row>
        )}

        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
              {parseFloat(cart.total)?.toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items / Total Qty:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
              {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
            </p>
          </Col>
        </Row>
      </div>

      {/* Right: total amount + hold/cancel */}
      <div style={{ height: "23.7vh", width: "40%", fontSize: "1vw" }}>
        <div
          id="sm-cart-total"
          onClick={() => {
            const updatedCart = {
              ...cart,
              layAway: "Y",
              docType: "Invoice",
              refundAmount: amount < 0 ? amount : 0,
            };
            setCart(updatedCart);
            verifyStock("Advance");
          }}
          style={{
            height: "18.2vh",
            position: "relative",
            background: themeJSON.totalAmountToPaySectionBGColor || "#2F3856",
            borderRadius: "7px",
            cursor: "pointer",
          }}
        >
          <p
            style={{
              padding: "0.7vw 0 0 1vw",
              color: "#fff",
              fontSize: "1em",
              fontWeight: "500",
              height: "4.5vh",
            }}
          >
            Total Amount To Pay
          </p>
          {cart.total !== undefined ? (
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "2.5em",
                fontWeight: "500",
                height: "14.4vh",
                width: "100%",
                alignItems: "flex-start",
                paddingTop: "1.2vh",
              }}
            >
              {" "}
              {parseFloat(cart.total)?.toFixed(pricePrecision)}
            </p>
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "2.5em",
                fontWeight: "500",
                height: "14.4vh",
                width: "100%",
              }}
            >
              {" "}
              0.00
            </p>
          )}
        </div>
        <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
          <Col span={12} onClick={openDisplayParkedBillModal}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "500",
                textAlign: "left",
                border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                height: "4.8vh",
                borderRadius: "5px",
                cursor: "pointer",
                backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
              }}
            >
              <img src={Hold} style={{ height: "2.5vh" }} />
              <span
                style={{
                  margin: "0",
                  textAlign: "center",
                  color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                  paddingLeft: "0.5vw",
                  fontSize: "1em",
                  fontWeight: 500,
                }}
              >
                Hold
              </span>
            </div>
          </Col>
          <Col span={12}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: "500",
                justifyContent: "center",
                border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                height: "4.8vh",
                borderRadius: "5px",
                cursor: "pointer",
                backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
              }}
              id="sm-delete-cart"
              onClick={deleteProductModal}
            >
              <img src={Cancel} style={{ height: "2.5vh" }} />
              <span
                style={{
                  textAlign: "center",
                  margin: "0",
                  color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                  paddingLeft: "0.5vw",
                  fontSize: "1em",
                  fontWeight: 500,
                }}
              >
                Cancel
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CartSummary;
